// REPLACED
import React from "react";
import OffsetRequestPage from "../../v2/pages/Transactions/OffsetRequestPage";

/**
 * Legacy Wrapper for Offset Request Module.
 * Redirects to the V2 implementation.
 */
function OffsetRequest({ user, userAccess, isHideSideMenu }) {
  return (
    <OffsetRequestPage
      user={user}
      userAccess={userAccess}
      isHideSideMenu={isHideSideMenu}
    />
  );
}

export default OffsetRequest;